import { Tabs } from "@frends/ui-components/react";

export default Tabs;
